// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__heFLG","title":"styles_title__1_paC"};